import { CancelToken } from 'axios'
import apiInstance from '../../../../backend-api.setup'
import { ApiPathConfig } from '../../../../../config/ApiPathConfig'
import { AnalyticOutputLayoutSizeEnum } from '../../../../../enums/analytic-output-layout-size.enum'

export const putTitleOutputService = (
  reportId: string,
  inputId: string,
  outputId: string,
  titleObject: {
    text: string
    level: number
    layout_size: AnalyticOutputLayoutSizeEnum
  },
  cancelToken?: CancelToken,
) =>
  apiInstance.put(
    ApiPathConfig.TITLE_OUTPUT_BY_ID(reportId, inputId, outputId),
    titleObject,
    {
      cancelToken,
    },
  )
